import { Capacitor } from "@capacitor/core";

// Retour haptique léger (téléphone). Natif : plugin Capacitor Haptics ; web Android : navigator.vibrate ;
// iOS web : rien (non supporté). Toujours silencieux en cas d'échec.
let plugin = null;
const load = async () => {
  if (plugin !== null) return plugin;
  try { plugin = await import("@capacitor/haptics"); } catch { plugin = false; }
  return plugin;
};

const vibrate = (pattern) => { try { navigator.vibrate?.(pattern); } catch { /* noop */ } };

export const hapticLight = async () => {
  if (Capacitor.isNativePlatform()) {
    const h = await load();
    if (h) { try { await h.Haptics.impact({ style: h.ImpactStyle.Light }); return; } catch { /* plugin absent → repli */ } }
  }
  vibrate(8);
};

export const hapticSuccess = async () => {
  if (Capacitor.isNativePlatform()) {
    const h = await load();
    if (h) { try { await h.Haptics.notification({ type: h.NotificationType.Success }); return; } catch { /* repli */ } }
  }
  vibrate([10, 40, 12]);
};

// Alerte (batterie faible en direct…) : vibration marquée pour être sentie téléphone en main.
export const hapticWarning = async () => {
  if (Capacitor.isNativePlatform()) {
    const h = await load();
    if (h) { try { await h.Haptics.notification({ type: h.NotificationType.Warning }); return; } catch { /* repli */ } }
  }
  vibrate([60, 60, 60, 60, 120]);
};
